import { Component, OnInit } from '@angular/core';
import { AlertService } from '../Services/alert';


@Component({
  selector: 'alert',
  templateUrl: '../Templates/alert.html'
})


export class AlertComponent {

  alert: any;
  private timer: any;
  private timeout: number = 5000;

  constructor(private alertService: AlertService) { }

  ngOnInit() {
    this.alertService.getAlert().subscribe(
      alert => {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.alert = alert;

        if (this.alert && !this.alert.persist) {

          this.timer = setTimeout(() => { this.closeAlert() }, this.timeout);
        }
      });
  }

  /**
   * Notify the alert service that the alert has been seen.
   */
  public closeAlert() {
    this.alertService.seen();
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/alert.ts